import React from 'react';
import { CTAButton } from './CTAButton';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-12 md:py-32 px-4 bg-gradient-to-br from-kid-purple via-kid-pink to-kid-sky text-white text-center relative overflow-hidden" data-id="element-129">
      <div className="max-w-4xl mx-auto relative z-10 bg-white/10 backdrop-blur-sm p-8 md:p-20 rounded-2xl border border-white/20 shadow-sm" data-id="element-130">
        <FadeIn data-id="element-131">
          <h2 className="text-2xl md:text-5xl font-bold mb-5 md:mb-8 leading-tight" data-id="element-132">
            <span className="block mb-1 md:mb-2 text-white/90" data-id="element-133">
              Una vez más,
            </span>
            <span className="block text-white" data-id="element-134">el problema no es tu hijo.</span>
          </h2>

          <div className="text-sm md:text-lg text-white/90 font-medium mb-6 md:mb-10 leading-relaxed space-y-4 md:space-y-6" data-id="element-135">
            <p className="bg-black/10 py-2 px-4 md:px-6 rounded-lg inline-block border border-white/10" data-id="element-136">
              Es el orden del proceso.
            </p>

            <p className="mt-4 md:mt-6" data-id="element-137">Y cuando el orden cambia...</p>

            <p className="text-xl md:text-3xl font-bold text-kid-yellow mt-3 md:mt-4" data-id="element-138">
              el aprendizaje también cambia.
            </p>
          </div>

          <div className="mt-8 md:mt-12" data-id="element-139">
            <CTAButton text="QUIERO ACCEDER AL SISTEMA »" size="xl" className="w-full sm:w-auto" animatePulse={true} data-id="element-140" />
          </div>

          <div className="mt-4 md:mt-6 inline-flex items-center gap-3 bg-black/10 py-2 px-4 md:px-6 rounded-lg border border-white/10" data-id="element-141">
            <span className="text-white/90 font-medium text-xs md:text-sm" data-id="element-142">
              Acceso inmediato
            </span>
            <span className="text-white/50" data-id="element-143">·</span>
            <span className="text-white/90 font-medium text-xs md:text-sm" data-id="element-144">
              Pago único
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}